import { AfterViewInit, Component, OnInit, ViewChild, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

import {
  NbContextMenuDirective,
  NbDialogService,
  NbIconModule,
  NbMenuItem,
  NbMenuModule,
  NbMenuService,
  NbUserModule,
} from '@nebular/theme';
import { AvatarComponent } from 'ngx-avatars';

import { OneColumnLayoutComponent } from '../@theme/layouts';
import { AuthService } from '../auth/services/auth.service';
import { MENU_BOTTOM_ITEMS, MENU_ITEMS } from './pages-menu';
import { SupportDialogComponent } from './support-dialog/support-dialog.component';

@Component({
  selector: 'ngx-pages',
  styleUrls: ['pages.component.scss'],
  template: `
    <ngx-one-column-layout>
      <nb-menu [items]="menu" tag="mainMenu"></nb-menu>
      <div class="bottom-menu">
        <div id="user-menu" class="mb-2 tw:cursor-pointer" (click)="openUserPage()">
          <ngx-avatars [name]="userName" size="30" class="me-4"></ngx-avatars>
          <span class="user-name">{{ userName }}</span>
        </div>
        <nb-menu class="main-bottom-menu" [items]="menuBottom" tag="mainMenuBottom"></nb-menu>
      </div>
    </ngx-one-column-layout>
  `,
  imports: [OneColumnLayoutComponent, NbMenuModule, NbUserModule, NbIconModule, AvatarComponent],
})
export class PagesComponent implements OnInit, AfterViewInit {
  private authService = inject(AuthService);
  private nbMenuService = inject(NbMenuService);
  private titleService = inject(Title);
  private router = inject(Router);
  private dialogService = inject(NbDialogService);

  @ViewChild(NbContextMenuDirective, { static: false }) contextMenu: NbContextMenuDirective;

  menu = MENU_ITEMS;
  menuBottom = MENU_BOTTOM_ITEMS;
  userName: string;

  ngOnInit() {
    this.userName = this.authService.userInfo?.fullName?.split(' ')[0];
    this.nbMenuService.onItemClick().subscribe((menuBag) => {
      if (menuBag.tag === 'mainMenu') {
        this.titleService.setTitle(menuBag.item.title);
      }

      if (menuBag.tag === 'mainMenuBottom') {
        this.titleService.setTitle(menuBag.item.title);
        switch (menuBag.item.title) {
          case 'Support':
            this.dialogService.open(SupportDialogComponent).onClose.subscribe();
            break;
          case 'Logout':
            this.logout();
            break;
          default:
            this.router.navigate([menuBag.item.link]);
        }
      }
    });

    this.filterMenu(this.menu);
  }

  ngAfterViewInit() {
    this.clearNbMenuTooltips();
  }

  private clearNbMenuTooltips() {
    const elements = document.querySelectorAll('ul.menu-items > li > a[title]');
    for (const element of elements as any) {
      element.title = '';
    }
  }

  filterMenu(menu: NbMenuItem[]) {
    for (const item of menu) {
      item.hidden =
        (item?.data?.permissions && !this.authService.checkPermissions(item.data?.permissions ?? [])) ||
        (item?.data?.isRootRoleRequired && !this.authService.hasRootPermission);
      if (item.children) {
        this.filterMenu(item.children);
      }
    }
  }

  openUserPage() {
    this.router.navigate(['/account']);
  }

  logout() {
    this.authService.logout().subscribe(() => {
      window.location.href = '/auth/login';
    });
  }
}
